export const prizesList = [
  {
    id: "aoc-c27g2u",
    name: "Игровой монитор AOC C27G2U",
    preview: require("@/assets/img/prizes/2021/aoc-c27g2u-preview.png"),
    href: "https://bit.ly/AOC_rr_2"
  },
  {
    id: "cooler-master-caliber-r1",
    name: "Игровое кресло Cooler Master Caliber R1",
    preview: require("@/assets/img/prizes/2021/cooler-master-caliber-r1-preview.png"),
    href: "https://clc.am/purple"
  },
  {
    id: "hyperx-quadcast",
    name: "Микрофон HyperX QuadCast",
    preview: require("@/assets/img/prizes/2021/hyperx-quadcast-preview.png"),
    href: "https://hyperx.gg/RBRR_QuadCast"
  },
  {
    id: "cooler-master-jacket",
    name: "Куртка Cooler Master",
    preview: require("@/assets/img/prizes/2021/cooler-master-jacket-preview.png"),
    href: "https://bit.ly/insta_cc"
  },
  {
    id: "hyperx-pulsefire-haste",
    name: "Игровая мышь HyperX Pulsefire Haste",
    preview: require("@/assets/img/prizes/2021/hyperx-pulsefire-haste-preview.png"),
    href: "https://hyperx.gg/RBRR_Raid"
  },
  {
    id: "hyperx-pulsefire-surge",
    name: "Игровая мышь HyperX Pulsefire Surge",
    preview: require("@/assets/img/prizes/2021/hyperx-pulsefire-surge-preview.png"),
    href: "https://hyperx.gg/RBRR_Raid"
  },
  {
    id: "hyperx-alloy-origins",
    name: "Механическая клавиатура HyperX Alloy Origins",
    preview: require("@/assets/img/prizes/2021/hyperx-alloy-origins-preview.png"),
    href: "https://hyperx.gg/RBRR_Origins"
  },
  {
    id: "hyperx-fury-ultra",
    name: "Коврик для мыши HyperX FURY Ultra",
    preview: require("@/assets/img/prizes/2021/hyperx-fury-ultra-preview.png"),
    href: "http://bit.ly/2MqAAh4"
  },
  {
    id: "cooler-master-mb511-argb",
    name: "Корпус Cooler Master MB511 ARGB",
    preview: require("@/assets/img/prizes/2021/cooler-master-mb511-argb-preview.png"),
    href: "https://clc.am/MB511ARGB"
  },
  {
    id: "cooler-master-tshirt",
    name: "Футболка Cooler Master",
    preview: require("@/assets/img/prizes/2021/cooler-master-tshirt-preview.png"),
    href: "https://bit.ly/insta_cc"
  }
];

const prizes = {};
prizesList.forEach(item => (prizes[item.id] = item));

export const prizesDict = prizes;
